export const normalizeLanguages = (languages) => {
  return languages.map((language) => ({
    id: language.id,
    langISOCode: language.langISOCode,
  }));
};

export const getSelectedLanguageISO = (languages, languageISOCode, fallbackLanguageId) => {
  const inputLanguage = languages.find((language) => language.langISOCode === languageISOCode);
  if (inputLanguage) return inputLanguage.langISOCode;

  // No exact locale match: fall back to another locale in the same language
  // (e.g. use "en-ca" when the requested "en-us" is unavailable) before
  // falling back to the default language.
  const prefix = (languageISOCode || '').split('-')[0];
  const sameLanguage = prefix && languages.find((language) => language.langISOCode.split('-')[0] === prefix);
  if (sameLanguage) return sameLanguage.langISOCode;

  const fallbackLanguage = languages.find((language) => Number(language.id) === fallbackLanguageId);
  // If english is not part of the survey languages, use the first language in the list
  return fallbackLanguage ? fallbackLanguage.langISOCode : languages[0].langISOCode;
};
